<template>
	<div class="user-list">
		<div >
			<el-button @click="inserUser(2)" v-if="userType=='admin'">新增用户</el-button>
		</div>
		<el-table :data="list" border>
			<el-table-column prop="id" label="ID" />
			<el-table-column prop="username" label="账号" />
			<el-table-column prop="name" label="姓名" />
			<el-table-column prop="orgName" label="用户机构" />
			
			<el-table-column prop="status" label="状态">
				<template slot-scope="scope">
					<el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
						{{ scope.row.status === 0 ? '正常' : '禁用' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="isLogin" label="登陆状态">
				<template slot-scope="scope">
					<el-tag :type="scope.row.isLogin === 1 ? 'success' : 'danger'">
						{{ scope.row.isLogin === 1 ? '在线' : '离线' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="roleType" label="用户类型">
				<template slot-scope="scope">
					{{scope.row.roleType==1?"超管用户":"普通用户"}}
				</template>
			</el-table-column>
			<el-table-column prop="lastLoginTime" label="最后登陆时间">
				<template slot-scope="scope">
						{{formatTime(scope.row.lastLoginTime)}}
					</template>
				</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="inserUser(1,scope.row)">编辑</el-button>
					<el-button type="text" style="color: red;" danger @click="handleDelete(scope.row.id)" v-if="scope.row.roleType===0">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination v-model:current-page="pageNum" v-model:page-size="pageSize" :total="total"
			layout="total, prev, pager, next" @size-change="getList" @current-change="getList"
			style="margin-top:20px;text-align:right" />
			<!-- 修改用户弹窗 -->
			<el-dialog :title="title" :visible.sync="isUser" width="400px" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" center>
				<el-form :model="from"  label-width="120px">
					<el-form-item label="用户名称" prop="name">
						<el-input v-model="from.name" placeholder="请输入用户名称" maxlength="20"></el-input>
					</el-form-item>
					<el-form-item label="用户密码" prop="password">
						<el-input v-model="from.password" type="password" placeholder="请输入用户密码" maxlength="20"></el-input>
					</el-form-item>
					<el-form-item label="重新输入密码" prop="newPassword">
						<el-input v-model="from.newPassword" type="password" placeholder="请输入用户密码" maxlength="20"></el-input>
					</el-form-item>
					
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="isUser = false">取消</el-button>
					<el-button type="primary" @click="admitUser">确定</el-button>
				</div>
			</el-dialog>
			<changeText :show.sync="showChangeText" :userName="loginUser" @success="refreshUserName" />
	</div>
</template>

<script>
	import changeText from '../../vue/changeText.vue'
	export default {
		name: 'UserList',
		components: {
			changeText
		},
		props: {
			// 接收用户类型：admin/school/parent/student/edu
			userType: {
				type: String,
				required: true,
			},
			refreshKey: {
				type: Number,
				default: 0,
			},
		},
		data() {
			return {
				list: [],
				pageNum: 1,
				pageSize: 10,
				total: 0,
				userId:localStorage.getItem('userId'),
				loginUser: localStorage.getItem('nickName'),
				title:'',
				isUser:false,
				from:{
					name:'',
					password:'',
					newPassword:''
				},
				showChangeText:false,
				login:null,
				
			}
		},
		watch: {
			// 切换类型 / 刷新 → 重新加载
			userType: {
				handler: 'getList',
				immediate: true,
			},
			// refreshKey: 'getList',
		},
		methods: {
			// 加载
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			formatTime(timestamp) {
			  if (!timestamp) return '-'
			  const date = new Date(timestamp)
			  const year = date.getFullYear()
			  const month = (date.getMonth() + 1).toString().padStart(2, '0')
			  const day = date.getDate().toString().padStart(2, '0')
			  const hours = date.getHours().toString().padStart(2, '0')
			  const minutes = date.getMinutes().toString().padStart(2, '0')
			  const seconds = date.getSeconds().toString().padStart(2, '0')
			  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
			},
			refreshUserName(){
				this.getList()
			},
			// 获取列表（根据类型）
			async getList() {
			    // 一进来先清空
			    this.list = []
			    this.total = 0
			    
			    this.loginOpen('数据查询中...')
			    try {
			        const apiPath = this.API[this.userType].getUserList
			        const res = await this.API.get(apiPath, {
			            pageNum: this.pageNum,
			            pageSize: this.pageSize
			        })
			        this.list = res.data.data.records || []
			        this.total = res.data.data.total || 0
			    } catch (e) {
			        // 异常也强制清空！
			        this.list = []
			        this.total = 0
			    } finally {
			        this.noLogin()
			    }
			},
			inserUser(type,row){
				if(type===1){
					this.showChangeText=true
				}else{
					this.title='新增用户'
					this.from={
					name:'',
					password:'',
					newPassword:''
				}
					this.isUser=true
				}
				
			},
			async admitUser(){
				this.loginOpen('添加用户中...')
				let from=this.from
				if(from.name.length<2) return this.$message('用户名需不得小于2位')
				if(from.password.length<8) return this.$message('密码未输入或小于8位')
				if(from.password!=from.newPassword) return this.$message('输入的密码不一致')
				try{
					const apiPath = this.API[this.userType].addAdminUser
					const res = await this.API.post(apiPath,{
						  "username": "test",
						  "password": from.password,
						  "name": from.name,
						  "status": 0,
						  "roleType": 0
					})
					
					if(res.data.code===200){
						this.isUser=false
						this.pageNum=1
						this.getList()
						
					}
				}catch(e){
					this.$message.error('添加失败')
				} finally{
					this.noLogin()
				}
				
			},
			// 删除
			async handleDelete(id) {
				this.$confirm('确定删除？').then(async () => {
					try {
						// ✅ 你想要的动态API写法（完全正确）
						const apiPath = this.API[this.userType].deleteUserRemove
						const res = await this.API.deleted(apiPath+`${id}`)
						if(res.data.code===200){
							this.$message.success('删除成功')
							this.getList()
						}
					} catch (e) {
						this.$message.error('删除失败')
					}
					
				})
			},
		},
	}
</script>